'use client';

import Badge from '@/common/Badge';
import { InvestingTournamentStatus } from '@/lib/Tournaments/types';
import TournamentsUtils from '@/utils/TournamentsUtils';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface ITournamentBadgeProps {
  status: InvestingTournamentStatus;
  children?: React.ReactNode;
}

function TournamentStatusBadge({ status }: ITournamentBadgeProps) {
  return (
    <Badge variant="default" icon={<FontAwesomeIcon icon={faCircle} className={twMerge(TournamentsUtils.TOURNAMENT_STATUS_ICON_COLOR[status], "size-3")} />}>
      {TournamentsUtils.TOURNAMENT_STATUS_BADGE[status] || status}
    </Badge>
  );
}

export default TournamentStatusBadge;
